import { createRouter, createWebHistory } from 'vue-router';
import Body from '@/layout/Body.vue';
import { routes } from './routes';
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        // Public auth routes (no layout)
        {
            path: routes.Auth.Login,
            name: 'Login',
            component: () => import('@/pages/auth/LoginPage.vue'),
            meta: { requiresAuth: false },
        },
        {
            path: routes.Auth.Register,
            name: 'Register',
            component: () => import('@/pages/auth/RegisterPage.vue'),
            meta: { requiresAuth: false },
        },
        // AmoCRM OAuth callback
        {
            path: routes.Integrations.AmoCRMCallback,
            name: 'AmoCRMCallback',
            component: () => import('@/pages/integrations/AmoCRMCallbackPage.vue'),
            meta: { requiresAuth: false },
        },
        // Protected routes
        {
            path: '/',
            component: Body,
            meta: { requiresAuth: true },
            children: [
                { path: '', redirect: routes.Dashboard },
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: () => import('@/pages/dashboard/DashboardPage.vue'),
                    meta: { mainTitle: 'Панель управления', title: 'Панель управления', breadcrumb: [{ text: 'Главная' }] },
                },
                // Bots
                {
                    path: 'bots',
                    name: 'Bots',
                    component: () => import('@/pages/bots/BotsPage.vue'),
                    meta: { mainTitle: 'Боты', title: 'Боты', breadcrumb: [{ text: 'Боты' }] },
                },
                {
                    path: 'bots/new',
                    name: 'CreateBot',
                    component: () => import('@/pages/bots/CreateBotPage.vue'),
                    meta: { mainTitle: 'Создать бота', title: 'Новый бот', breadcrumb: [{ text: 'Боты', subText: 'Создать' }] },
                },
                {
                    path: 'bots/:id',
                    name: 'BotDetail',
                    component: () => import('@/pages/bots/BotDetailPage.vue'),
                    meta: { mainTitle: 'Бот', breadcrumb: [{ text: 'Боты', subText: 'Детали' }] },
                    children: [
                        { path: '', name: 'BotOverview', component: () => import('@/pages/bots/BotOverviewTab.vue') },
                        { path: 'questions', name: 'BotQuestions', component: () => import('@/pages/bots/QuestionsPage.vue'), meta: { mainTitle: 'Вопросы', breadcrumb: [{ text: 'Боты', subText: 'Вопросы' }] } },
                        { path: 'deal-rules', name: 'BotDealRules', component: () => import('@/pages/bots/DealRulesPage.vue'), meta: { mainTitle: 'Правила сделок', breadcrumb: [{ text: 'Боты', subText: 'Правила сделок' }] } },
                        { path: 'reminders', name: 'BotReminders', component: () => import('@/pages/bots/RemindersPage.vue'), meta: { mainTitle: 'Напоминания', breadcrumb: [{ text: 'Боты', subText: 'Напоминания' }] } },
                        { path: 'conversations', name: 'BotConversations', component: () => import('@/pages/bots/ConversationsPage.vue'), meta: { mainTitle: 'Диалоги', breadcrumb: [{ text: 'Боты', subText: 'Диалоги' }] } },
                        { path: 'utm', name: 'BotUTM', component: () => import('@/pages/bots/UTMLinksPage.vue'), meta: { mainTitle: 'UTM-ссылки', breadcrumb: [{ text: 'Боты', subText: 'UTM' }] } },
                        { path: 'ai', name: 'BotAI', component: () => import('@/pages/bots/BotAIPage.vue'), meta: { mainTitle: 'AI-ассистент', breadcrumb: [{ text: 'Боты', subText: 'AI-ассистент' }] } },
                    ],
                },
                // Campaigns
                {
                    path: 'campaigns',
                    name: 'Campaigns',
                    component: () => import('@/pages/campaigns/CampaignsListPage.vue'),
                    meta: { mainTitle: 'Рассылки', breadcrumb: [{ text: 'Рассылки' }] },
                },
                {
                    path: 'campaigns/new',
                    name: 'CreateCampaign',
                    component: () => import('@/pages/campaigns/CampaignCreatePage.vue'),
                    meta: { mainTitle: 'Новая рассылка', breadcrumb: [{ text: 'Рассылки', subText: 'Создать' }] },
                },
                {
                    path: 'campaigns/:id',
                    name: 'CampaignDetail',
                    component: () => import('@/pages/campaigns/CampaignDetailPage.vue'),
                    meta: { mainTitle: 'Рассылка', breadcrumb: [{ text: 'Рассылки', subText: 'Детали' }] },
                },
                // Templates
                {
                    path: 'templates',
                    name: 'Templates',
                    component: () => import('@/pages/templates/TemplatesListPage.vue'),
                    meta: { mainTitle: 'Шаблоны', breadcrumb: [{ text: 'Шаблоны' }] },
                },
                // Integrations
                {
                    path: 'integrations',
                    name: 'Integrations',
                    component: () => import('@/pages/integrations/IntegrationsPage.vue'),
                    meta: { mainTitle: 'Интеграции', breadcrumb: [{ text: 'Интеграции' }] },
                },
                {
                    path: 'integrations/amocrm/:id',
                    name: 'AmoCRMDetail',
                    component: () => import('@/pages/integrations/AmoCRMDetailPage.vue'),
                    meta: { mainTitle: 'AmoCRM', breadcrumb: [{ text: 'Интеграции', subText: 'AmoCRM' }] },
                },
                // Analytics
                {
                    path: 'analytics',
                    name: 'AnalyticsDashboard',
                    component: () => import('@/pages/analytics/AnalyticsDashboardPage.vue'),
                    meta: { mainTitle: 'Аналитика', breadcrumb: [{ text: 'Аналитика' }] },
                },
                {
                    path: 'analytics/bots/:id',
                    name: 'BotAnalytics',
                    component: () => import('@/pages/analytics/BotAnalyticsPage.vue'),
                    meta: { mainTitle: 'Аналитика бота', breadcrumb: [{ text: 'Аналитика', subText: 'Бот' }] },
                },
                // Unanswered questions registry
                {
                    path: 'unanswered',
                    name: 'Unanswered',
                    component: () => import('@/pages/admin/UnansweredPage.vue'),
                    meta: { mainTitle: 'Неотвеченные вопросы', breadcrumb: [{ text: 'Неотвеченные вопросы' }] },
                },
                // Settings
                {
                    path: 'settings',
                    name: 'Settings',
                    component: () => import('@/pages/settings/SettingsPage.vue'),
                    meta: { mainTitle: 'Настройки', breadcrumb: [{ text: 'Настройки' }] },
                },
            ],
        },
        // Error pages
        {
            path: '/error/500',
            name: 'Error500',
            component: () => import('@/pages/error/Error500.vue'),
            meta: { requiresAuth: false },
        },
        // Catch-all 404
        {
            path: '/:pathMatch(.*)*',
            name: 'Error404',
            component: () => import('@/pages/error/Error404.vue'),
            meta: { requiresAuth: false },
        },
    ],
});
// Auth guard
let userLoadPromise = null;
router.beforeEach(async (to) => {
    const { useAuthStore } = await import('@/stores/auth');
    const authStore = useAuthStore();
    // On first load (or concurrent navigations during load), wait for user to be fetched
    if (!userLoadPromise && authStore.isLoading) {
        userLoadPromise = authStore.loadUser();
    }
    if (userLoadPromise) {
        await userLoadPromise;
        userLoadPromise = null;
    }
    if (to.meta.requiresAuth !== false && !authStore.isAuthenticated) {
        return '/login';
    }
    if (to.meta.requiresAuth === false && authStore.isAuthenticated && (to.path === '/login' || to.path === '/register')) {
        return '/dashboard';
    }
});
export default router;
